const translations: Record<string, Record<string, string>> = {
  en: {
    loading: "Loading (may take up to 2 minutes…)",
    move: "Move your head slowly to complete the circle.",
    camera_not_granted: "Camera access was not granted, please reopen the app",
    smile: "Please, smile.",
    dont_smile: "Please, don't smile.",
    another_face: "Another face detected.",
    already_passed_message: "You have successfully confirmed your age!",
    already_rejected_message:
      "Unfortunately our system detected you are underage. Please contact support in case of mistake",
    try_later_message: "Please try to pass verification later",
  },
  ru: {
    loading: "Загрузка (может занимать до 2 минут…)",
    move: "Медленно поворачивайте голову, чтобы заполнить круг.",
    camera_not_granted:
      "Доступ к камере не был предоставлен, пожалуйста, откройте приложение заново",
    smile: "Пожалуйста, улыбнитесь.",
    dont_smile: "Пожалуйста, не улыбайтесь.",
    another_face: "Обнаружено другое лицо.",
    already_passed_message: "Вы успешно подтвердили свой возраст!",
    already_rejected_message:
      "К сожалению, система определила, что вы несовершеннолетний. В случае ошибки, свяжитесь со службой поддержки",
    try_later_message: "Пожалуйста, попробуйте пройти проверку позже",
  },
};

const SUPPORTED_LANG_KEYS = Object.keys(translations) as string[];
const DEFAULT_LANG = "en";

function getLanguage(): string {
  if (typeof window === "undefined") {
    return DEFAULT_LANG;
  }
  const urlLang = new URLSearchParams(window.location.search).get("lang");
  if (urlLang && SUPPORTED_LANG_KEYS.includes(urlLang)) {
    return urlLang;
  }
  if (navigator.language) {
    const lang = navigator.language.split("-")[0];
    if (translations[lang]) return lang;
  }
  return DEFAULT_LANG;
}

const currentLang =
  typeof navigator !== "undefined" ? getLanguage() : DEFAULT_LANG;

export function t(key: string): string {
  return translations[currentLang]?.[key] ?? translations.en?.[key] ?? key;
}
